export default __webpack_public_path__ + "static/media/close_modal.54e82618.svg";